<script setup lang="ts">
  const projectConfig = useProjectConfig();
</script>

<template>{{ projectConfig.title }} &copy; {{ new Date().getFullYear() }}</template>
